export const shallowClone = (input) => {
    return Object.assign(input);
}